/* NEO Liquid LP — page-shell behaviour (vanilla JS, no jQuery).
   All interaction is delegated at document level so it survives the theme
   editor / hot-reload re-rendering the section (which replaces the DOM). */
(function () {
  "use strict";

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }

  /* ---- Press carousel: N cards per view, auto-advance, swipe, dots ---- */
  var AUTOPLAY_MS = 5000;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function perView() {
    var w = window.innerWidth;
    return w <= 640 ? 1 : (w <= 1024 ? 2 : 3);
  }

  function carouselPages(root) {
    var slides = root.querySelectorAll(".neo-carousel__slide");
    return Math.max(1, Math.ceil(slides.length / perView()));
  }

  function carouselRender(root) {
    var track = root.querySelector(".neo-carousel__track");
    var status = root.querySelector(".neo-carousel__status");
    var dots = root.querySelector(".neo-carousel__dots");
    if (!track) return;
    var pages = carouselPages(root);
    var page = Math.min(parseInt(track.getAttribute("data-neo-page") || "0", 10), pages - 1);
    track.setAttribute("data-neo-page", String(page));
    track.style.transform = "translateX(-" + page * 100 + "%)";
    if (status) status.textContent = "Page " + (page + 1) + " of " + pages;
    if (dots) {
      if (dots.children.length !== pages) {
        dots.innerHTML = "";
        for (var i = 0; i < pages; i++) {
          var d = document.createElement("button");
          d.type = "button"; d.className = "neo-carousel__dot"; d.setAttribute("role", "tab");
          d.setAttribute("data-neo-page-to", String(i)); d.setAttribute("aria-label", "Go to page " + (i + 1));
          dots.appendChild(d);
        }
      }
      for (var j = 0; j < dots.children.length; j++) dots.children[j].setAttribute("aria-current", j === page ? "true" : "false");
    }
  }

  function carouselGo(root, delta, absolute) {
    var track = root.querySelector(".neo-carousel__track");
    if (!track) return;
    var pages = carouselPages(root);
    var page = parseInt(track.getAttribute("data-neo-page") || "0", 10);
    page = typeof absolute === "number" ? absolute : (page + delta + pages) % pages;
    track.setAttribute("data-neo-page", String(page));
    carouselRender(root);
  }

  function carouselAutoplay(root) {
    if (reduceMotion || root.getAttribute("data-neo-autoplay") === "1") return;
    root.setAttribute("data-neo-autoplay", "1");
    var timer = null, paused = false;
    function tick() { if (!paused && document.visibilityState === "visible") carouselGo(root, 1); }
    function start() { if (!timer) timer = setInterval(tick, AUTOPLAY_MS); }
    function restart() { if (timer) clearInterval(timer); timer = null; start(); }
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });
    root.addEventListener("click", restart);
    var x0 = null;
    root.addEventListener("touchstart", function (e) { paused = true; x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) carouselGo(root, dx < 0 ? 1 : -1); }
      x0 = null; paused = false; restart();
    }, { passive: true });
    start();
  }

  /* ---- FIX-E (R2 F1): in-page jumps that actually land on the target ----
     The old code measured the target once at tap time and smooth-scrolled to that number. Lazy images above the buy box
     load during the scroll and push it down, so on phones the page stopped ~1,200 px short (WebKit ~780 px).
     Now: smooth-scroll, wait until the scroll has come to rest, re-measure and correct (up to 5 times), then keep
     watching for 1.2 s for late image loads (iOS Safari has no scroll anchoring). Any real touch/wheel/key by the
     shopper cancels the correction so it never fights them. */
  var jump = null;
  function cancelJump() { if (jump) { jump.cancelled = true; jump = null; } }
  ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (ev) {
    window.addEventListener(ev, function (e) { if (jump && e.isTrusted && performance.now() - jump.t0 > 120) cancelJump(); }, { passive: true });
  });
  function headerOffset() {
    /* Only a header that is actually on screen covers the target (the theme wrapper can stop it from sticking). */
    var h = document.querySelector(".neo-lp .neo-header");
    if (!h || !sticks(h)) return 8;
    var r = h.getBoundingClientRect();
    return Math.round(Math.max(0, r.height) + 8);
  }
  function sticks(el) {
    if (getComputedStyle(el).position !== "sticky") return false;
    for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (/(hidden|auto|scroll)/.test(cs.overflowX + " " + cs.overflowY)) return false;
    }
    return true;
  }
  function jumpTo(target) {
    cancelJump();
    var j = jump = { cancelled: false, tries: 0, t0: performance.now() };
    function dest() { return Math.max(0, Math.round(target.getBoundingClientRect().top + window.pageYOffset - headerOffset())); }
    function maxY() { return document.documentElement.scrollHeight - window.innerHeight; }
    function move(y, smooth) {
      if (smooth && !reduceMotion) { window.scrollTo({ top: y, behavior: "smooth" }); return; }
      var de = document.documentElement, prev = de.style.scrollBehavior;
      de.style.scrollBehavior = "auto"; window.scrollTo(0, y); de.style.scrollBehavior = prev;
    }
    function settled() {
      [400, 1200].forEach(function (ms) {
        setTimeout(function () {
          if (j.cancelled) return;
          var d = dest(), y = window.pageYOffset;
          if (Math.abs(d - y) > 8 && !(y >= maxY() - 1 && d > y)) move(d, false);
          if (ms === 1200 && jump === j) jump = null;
        }, ms);
      });
    }
    var last = -1, still = 0, started = performance.now();
    function poll() {
      if (j.cancelled) return;
      var y = window.pageYOffset;
      still = Math.abs(y - last) < 1 ? still + 1 : 0;
      last = y;
      var elapsed = performance.now() - started;
      if ((still < 4 || elapsed < 250) && elapsed < 3500) { requestAnimationFrame(poll); return; }
      var d = dest();
      var stuckAtEnd = y >= maxY() - 1 && d > y;
      if (Math.abs(d - y) > 2 && !stuckAtEnd && j.tries < 5) {
        j.tries++;
        move(d, Math.abs(d - y) > 240);
        last = -1; still = 0; started = performance.now();
        requestAnimationFrame(poll);
        return;
      }
      settled();
    }
    move(dest(), true);
    requestAnimationFrame(poll);
  }

  /* ---- Delegated clicks: FAQ accordions, carousel arrows, anchors ---- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!closest(t, ".neo-lp")) return;

    var faqBtn = closest(t, ".neo-faq-item__q");
    if (faqBtn) {
      var item = closest(faqBtn, ".neo-faq-item");
      var panel = item ? item.querySelector(".neo-faq-item__a") : null;
      var isOpen = faqBtn.getAttribute("aria-expanded") === "true";
      faqBtn.setAttribute("aria-expanded", String(!isOpen));
      if (panel) { if (isOpen) panel.setAttribute("hidden", ""); else panel.removeAttribute("hidden"); }
      return;
    }

    var arrow = closest(t, "[data-neo-carousel]");
    if (arrow) {
      var car = closest(arrow, ".neo-carousel");
      if (car) carouselGo(car, arrow.getAttribute("data-neo-carousel") === "prev" ? -1 : 1);
      return;
    }
    var dot = closest(t, "[data-neo-page-to]");
    if (dot) {
      var car2 = closest(dot, ".neo-carousel");
      if (car2) carouselGo(car2, 0, parseInt(dot.getAttribute("data-neo-page-to"), 10));
      return;
    }

    var link = closest(t, 'a[href^="#"]');
    if (link) {
      var id = link.getAttribute("href").slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      jumpTo(target);
    }
  }, true);

  /* ---- Sticky bottom CTA: hide while the buy box itself is on screen -- */
  function initStickyCta() {
    var bar = document.querySelector(".neo-lp .neo-sticky-cta");
    var buybox = document.getElementById("neo-buybox");
    if (!bar || !buybox || !("IntersectionObserver" in window)) return;
    if (bar.getAttribute("data-neo-observed") === "1") return;
    bar.setAttribute("data-neo-observed", "1");
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.style.opacity = entry.isIntersecting ? "0" : "1";
        bar.style.pointerEvents = entry.isIntersecting ? "none" : "auto";
      });
    }, { threshold: 0.15 }).observe(buybox);
  }

  /* ---- v2.1: benefit-row loop video (was a 964 KB GIF). Muted + inline, played only while near the
     viewport, paused off screen; reduced motion keeps the poster. ---- */
  function initInviewVideos() {
    var vids = document.querySelectorAll(".neo-lp video[data-neo-inview-video]");
    if (!vids.length || reduceMotion) return;
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    Array.prototype.forEach.call(vids, function (v) {
      if (v.getAttribute("data-neo-observed") === "1") return;
      v.setAttribute("data-neo-observed", "1");
      v.muted = true;
      if (!("IntersectionObserver" in window)) { v.preload = "auto"; play(v); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (v.preload === "none") v.preload = "auto"; play(v); }
          else if (!v.paused) v.pause();
        });
      }, { rootMargin: "200px 0px" }).observe(v);
    });
  }

  /* ---- FIX-E (R2 speed T2): Okendo loads only when the reviews block is near (was eager in the section: a second,
     render-blocking copy of main.min.css + okendo-reviews.js at load, ~160 KB / 51 requests / 560 ms main thread). ---- */
  function initOkendo() {
    var host = document.querySelector(".neo-lp [data-neo-okendo]");
    if (!host || window.__neoOkendoLoaded) return;
    function load() {
      if (window.__neoOkendoLoaded) return;
      window.__neoOkendoLoaded = true;
      var css = host.getAttribute("data-neo-okendo-css");
      if (css && !document.querySelector('link[href*="okendo.io/styles/main.min.css"]')) {
        var l = document.createElement("link");
        l.rel = "stylesheet"; l.href = css;
        document.head.appendChild(l);
      }
      var sc = document.createElement("script");
      sc.src = host.getAttribute("data-neo-okendo"); sc.defer = true;
      document.head.appendChild(sc);
    }
    if (!("IntersectionObserver" in window)) { load(); return; }
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); }
    }, { rootMargin: "1200px 0px 1200px 0px" });
    io.observe(host);
  }

  function init() {
    var car = document.querySelector(".neo-lp .neo-carousel");
    if (car) { carouselRender(car); carouselAutoplay(car); }
    initStickyCta();
    initInviewVideos();
    initOkendo();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  var resizeT = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { var c = document.querySelector(".neo-lp .neo-carousel"); if (c) carouselRender(c); }, 150);
  });
})();
